import { render, staticRenderFns } from "./AddUnidentifiedStock.vue?vue&type=template&id=90fffddc"
import script from "./AddUnidentifiedStock.vue?vue&type=script&lang=js"
export * from "./AddUnidentifiedStock.vue?vue&type=script&lang=js"
import style0 from "./AddUnidentifiedStock.vue?vue&type=style&index=0&id=90fffddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports